import React from 'react';

import EstadoBloqueado from './EstadoBloqueado.jsx';
import EstadoBloqueadoInactividad from './EstadoBloqueadoInactividad.jsx';
import EstadoEliminado from './EstadoEliminado.jsx';

const Estado = (props) => {
    switch (props.estado) {
        case 1:
            return (
                <EstadoBloqueado
                    Nombre={props.bloqueadoPor}
                    Usuario={props.usuario}
                    Fecha={props.fechaBloqueado}
                    Hora={props.horaBloqueado}
                    ID={props.ID}
                    Motivo={props.motivo}
                    functions={props.functions}
                    setUserState={props.setUserState} />
            );
        case 2:
            return (
                <EstadoEliminado
                    Nombre={props.eliminadoPor}
                    Usuario={props.usuario}
                    Fecha={props.fechaEliminado}
                    Hora={props.horaEliminado}
                    ID={props.ID}
                    functions={props.functions}
                    setUserState={props.setUserState} />
            );
            case 3:
                return (
                    <EstadoBloqueadoInactividad
                        ID={props.ID}
                        functions={props.functions}
                        setUserState={props.setUserState} />
                );
        default:
            return (<div>&nbsp;</div>);
    }
}

export default Estado;